/**
 * Auth Layout
 * Layout for unauthenticated pages (login, register)
 */
import React from 'react';
import { Outlet, Navigate } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';
import { LoadingSpinner } from '../atoms/LoadingSpinner';

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50 dark:bg-[#050505]">
        <LoadingSpinner />
      </div>
    );
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default AuthLayout;
